import ServiceKPIStructureRecordLayout from './ServiceKPIStructureRecordLayout';
import { serviceKPIStructureRegistryConfig } from './serviceKPIStructureRegistryConfig';

const useServiceKPIStructureRegistry = () => ({
  ...serviceKPIStructureRegistryConfig,
  RecordLayout: ServiceKPIStructureRecordLayout,
});

export default useServiceKPIStructureRegistry;
